<template lang="">
  <div class="ms-tracking-item">
    <div class="ms-tracking-item__status">
      <div
        v-if="isProcessing"
        :class="iconStatus"
      >
        <div /><div /><div /><div />
      </div>
      <div
        v-else
        :class="[
          'icon24',
          iconStatus
        ]"
      />
    </div>
    <div
      v-tooltip="title"
      class="ms-tracking-item__title"
    >
      {{ title }}
    </div>
    <div
      v-if="showClose"
      class="ms-tracking-item__close-button icon20"
      @click="close"
    />
  </div>
</template>

<script>
import { computed, getCurrentInstance, onMounted, onUnmounted, defineComponent } from 'vue'
import { MSConstant } from '@/commons/wildcards'
import CommonFunction from '@/commons/commonFunction'

export default defineComponent({
  name: 'MsTrackingItem',

  props: {
    /**
     * Id
     */
    trackingId: {
      type: [String, Number],
      default: null,
    },
    /**
     * sự kiện lắng nghe
     */
    eventId: {
      type: [String, Number],
      default: null,
    },
    /**
     * Trạng thái
     */
    status: {
      type: Number,
      default: MSConstant.TrackingStatus.Processing,
    },
    /**
     * tiêu đề
     */
    title: {
      type: String,
      default: null,
    },
    /**
     * Có show button close khoong
     */
    showClose: {
      type: Boolean,
      default: true,
    },
    /**
     * callback socket
     */
    listener: {
      type: Function,
      default: () => {},
    },
    /**
     * thời gian ping lên server
     */
    intervalTime: {
      type: Number,
      default: null,
    },
    /**
     * Hàm ping lên server
     */
    intervalHandler: {
      type: Function,
      default: () => {},
    },
  },

  emits: ['close'],

  setup (props, { emit }) {
    const componentId = CommonFunction.generateUUID()
    const { proxy } = getCurrentInstance()
    let isSubcribeSocketEvent = false
    let intervalId = null

    const iconStatus = computed(() => {
      switch (props.status) {
        case MSConstant.TrackingStatus.Success:
          return 'success'
        case MSConstant.TrackingStatus.Error:
          return 'error'
        default:
          return 'processing'
      }
    })
    const isProcessing = computed(() => !(props.status !== MSConstant.TrackingStatus.Processing))

    const isFunction = (arg) => typeof arg === 'function'

    const close = () => {
      emit('close')
    }

    onMounted(() => {
      try {
        if (isFunction(props.listener) && proxy.sockets?.subscribe) {
          proxy.sockets.subscribe(props.eventId, props.listener)
          isSubcribeSocketEvent = true
        }
        if (props.intervalTime && isFunction(props.intervalHandler)) {
          intervalId = setInterval(props.intervalHandler, props.intervalTime)
        }
      } catch (ex) {
        //
      }
    })

    onUnmounted(() => {
      try {
        if (isSubcribeSocketEvent && proxy.sockets?.unsubscribe) {
          proxy.sockets.unsubscribe(props.eventId, props.listener)
        }
        if (props.intervalTime) {
          clearInterval(intervalId)
        }
      } catch (ex) {
        //
      }
    })

    return {
      iconStatus,
      isProcessing,
      close,
      componentId,
    }
  },
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsTrackingItem.scss';

.fade-enter-from {

}
.fade-enter-to {

}
.fade-enter-active {

}
.fade-leave-from {
  opacity: 1;
}
.fade-leave-to {
  opacity: 0;
}
.fade-leave-active {
  transition: all linear 0.3s;
}
</style>
